import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { walletAPI } from '../services/api';

const formatDate = (d) => d ? new Date(d).toLocaleDateString() : '—';

export default function FamilyMembers() {
  const navigate = useNavigate();
  const [policies, setPolicies] = useState([]);
  const [membersByPolicy, setMembersByPolicy] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const list = await walletAPI.listPolicies();
        const arr = Array.isArray(list) ? list : (list?.data ?? []);
        setPolicies(arr);
        const byPolicy = {};
        for (const p of arr) {
          try {
            const m = await walletAPI.getMembers(p.id);
            const members = Array.isArray(m) ? m : (m?.data ?? []);
            byPolicy[p.id] = { policy: p, members };
          } catch (_) {
            byPolicy[p.id] = { policy: p, members: [] };
          }
        }
        setMembersByPolicy(byPolicy);
      } catch (e) {
        console.warn(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <Container sx={{ py: 3 }}><Typography>Loading…</Typography></Container>;

  const allMembers = [];
  Object.entries(membersByPolicy).forEach(([policyId, { policy, members }]) => {
    members.forEach((m) => allMembers.push({ ...m, policyName: policy.policy_name || policy.policy_type, insurerName: policy.insurer_name }));
  });

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>Family Members</Typography>
      {allMembers.length === 0 ? (
        <Typography color="textSecondary">No family members across policies. Add members from policy details.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Policy</TableCell>
                <TableCell>Insurer</TableCell>
                <TableCell>DOB</TableCell>
                <TableCell>Relation</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allMembers.map((m) => (
                <TableRow key={m.id}>
                  <TableCell>{m.first_name} {m.last_name}</TableCell>
                  <TableCell>{m.policyName}</TableCell>
                  <TableCell>{m.insurerName}</TableCell>
                  <TableCell>{formatDate(m.date_of_birth)}</TableCell>
                  <TableCell>{m.relation_to_primary || '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Button sx={{ mt: 2 }} onClick={() => navigate('/wallet')}>Back to Wallet</Button>
    </Container>
  );
}
